import {
    FETCHING_SKILLS_REQUEST,
    FETCHING_SKILLS_FAILED,
    FETCHING_SKILLS_SUCCEEDED,
    CREATING_SKILL_REQUEST,
    CREATING_SKILL_SUCCEEDED,
    CREATING_SKILL_FAILED,
    DELETING_SKILL_REQUEST,
    DELETING_SKILL_FAILED,
    DELETING_SKILL_SUCCEEDED,
    UPDATING_SKILL_SUCCEEDED,
    UPDATING_SKILL_REQUEST,
    UPDATING_SKILL_FAILED
} from "./actionTypes";

import axios from 'axios';
import buildUrl from 'build-url-ts';

const apiUrl = `${process.env.REACT_APP_COACHING_API_URL}`;
const API_BASE_URL = `${apiUrl}/api/1.0`;
const SKILL_URL = `${API_BASE_URL}/skills`;

/**
 * Fetching skills
 */
export function fetchSkills(page) {
    return function (dispatch) {
        dispatch(fetchingSkills());

        const params = {
          page: page
        }

        return axios({
            method: "GET",
            url: SKILL_URL,
            params: params
        })
            .then(response => {
                return dispatch(fetchingSkillsSucceeded(response.data));
            })
            .catch(error => {
                return dispatch(fetchingSkillsFailed(error))
            })
    }
}

function fetchingSkills() {
    return {
        type: FETCHING_SKILLS_REQUEST,
        payload: {}
    }
}

function fetchingSkillsSucceeded(json) {
    return {
        type: FETCHING_SKILLS_SUCCEEDED,
        payload: json
    }
}

function fetchingSkillsFailed(error) {
    return {
        type: FETCHING_SKILLS_FAILED,
        payload: error
    }
}

/**
 * Creating Skill
 */
export function createSkill(request) {
    return function (dispatch) {
        dispatch(creatingSkill());

        return axios({
            method: "POST",
            url: SKILL_URL,
            data: request
        })
            .then(response => {
                return dispatch(creatingSkillSucceeded(response.data));
            })
            .catch(error => {
                return dispatch(creatingSkillFailed(error));
            })
    }
}

function creatingSkill() {
    return {
        type: CREATING_SKILL_REQUEST,
        payload: {}
    }
}

function creatingSkillSucceeded(json) {
    return {
        type: CREATING_SKILL_SUCCEEDED,
        payload: json
    }
}

function creatingSkillFailed(error) {
    return {
        type: CREATING_SKILL_FAILED,
        payload: error
    }
}

/**
 * Delete Skill
 */
export function deleteSkill(id) {
  return function(dispatch) {
    dispatch(deletingSkill(id));

    let url = buildUrl(SKILL_URL, {
      path: `${id}`
    });

    return axios({
      method: "DELETE",
      url: url
    })
    .then(response => {
      return dispatch(deletingSkillSucceeded(id, response.data));
    })
    .catch(error => {
      return dispatch(deletingSkillFailed(id, error));
    })
  }
}

function deletingSkill(id) {
  return {
    type: DELETING_SKILL_REQUEST,
    payload: id
  }
}

function deletingSkillSucceeded(id, json) {
  return {
    type: DELETING_SKILL_SUCCEEDED,
    payload: {
      id: id,
      resposne: json
    }
  }
}

function deletingSkillFailed(id, error) {
  return {
    type: DELETING_SKILL_FAILED,
    payload: {
      id: id, 
      error: error
    }
  }
}

/**
 * Updating Skill
 */
export function updateSkill(id, request) {
  return function(dispatch) {
    dispatch(updatingSkill(id));

    let url = buildUrl(SKILL_URL, {
      path: `${id}`
    });

    return axios({
      method: "PUT",
      url: url,
      data: request
    })
    .then(response => {
      return dispatch(updatingSkillSucceeded(id, response.data));
    })
    .catch(error => {
      return dispatch(updatingSkillFailed(id, error));
    })
  }
}

function updatingSkill(id) {
  return {
    type: UPDATING_SKILL_REQUEST,
    payload: id
  }
}

function updatingSkillSucceeded(id, json) {
return {
  type: UPDATING_SKILL_SUCCEEDED,
  payload: {
      id: id,
      response: json
    }
  }
}

function updatingSkillFailed(id, error) {
  return {
    type: UPDATING_SKILL_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}